import { render, staticRenderFns } from "./manage-subscription.vue?vue&type=template&id=5c724595&scoped=true"
import script from "./manage-subscription.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-subscription.vue?vue&type=script&setup=true&lang=js"
import style0 from "./manage-subscription.vue?vue&type=style&index=0&id=5c724595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c724595",
  null
  
)

export default component.exports